/**=========================================================
 * Module: sectors.js
 * Sectors Controller
 =========================================================*/


 App.controller('SectorsController',
 ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'DataService', 'ngDialog', '$filter', 'toaster',
     function ($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D, ngDialog, $filter, toaster) {
         "use strict";

         $scope.type = 'group';
         $scope.id = $state.params.filter;

         $scope.model = {};
         $scope.error = {};
         $scope.page = {
             title: 'labels.SECTORS',
             subTitle: ''
         };

         $scope.pop = function(type, title, text) {
            toaster.pop(type, title, text, 0, 'trustedHtml');
        };

         $scope.initialized = false;
         $scope.watchActivated = false;
         $scope.init = function () {

             if ($rootScope.user.id && ($scope.id != 'undefined')) {
                 $scope.initialized = true;

                 if($rootScope.user.groupType=='ADMIN'){
                     D.load('group', $scope.id, { cache: false }).then(function (result) {
                         $scope.client = result;
                         $scope.page.subTitle = result.name;
                        
                         $scope.client.sectors = result.sectors || []

                         $scope.client.sectors.push({id:'',name:''})

                         D.query('account', 'group=' + $scope.id, { cache: false }).then(function(result){
                            $scope.accounts = result;
                            
                            let accountsBySector = {}
                            for(let i=0; i<$scope.accounts.length; i++){
                                if($scope.accounts[i].sectors){
                                    for(let j=0; j<$scope.accounts[i].sectors.length; j++){
                                        let l = $scope.accounts[i].sectors[j]
                                        if(!accountsBySector[l]) accountsBySector[l] = []
                                        accountsBySector[l].push($scope.accounts[i].id)
                                    }
                                }
                                if($scope.accounts[i].superUser){
                                    $scope.accounts[i].name += ' [SUPERUSER]'
                                }
                            }

                            $scope.forms = {}
                            for(let i in $scope.client.sectors){
                                $scope.client.sectors[i].sectorId = $scope.client.sectors[i].id
                                $scope.client.sectors[i].id = $scope.id
                                $scope.client.sectors[i].users = !$scope.client.opts.maxOneUserPerSector ? accountsBySector[$scope.client.sectors[i].sectorId] : null
                                $scope.client.sectors[i].user = accountsBySector[$scope.client.sectors[i].sectorId] ? accountsBySector[$scope.client.sectors[i].sectorId][0] : null
                                $scope.forms[$scope.client.sectors[i].sectorId] = {
                                    title: '',
                                    status: '',
                                    type: 'group',
                                    model: $scope.client.sectors[i],
                                    fields: [{
                                        available: true,
                                        type: 'text',
                                        name: 'name',
                                        required: true,
                                        column: 4,
                                        labelColumn: 3,
                                        inputColumn: 9
                                    },{
                                        available: !$scope.client.opts.maxOneUserPerSector,
                                        type: 'multiselect',
                                        name: 'users',
                                        data: $scope.accounts,
                                        valueField: 'id',
                                        labelField: 'name',
                                        column: 4,
                                        labelColumn: 3,
                                        inputColumn: 9
                                    },{
                                        available: $scope.client.opts.maxOneUserPerSector,
                                        type: 'select',
                                        name: 'user',
                                        data: $scope.accounts,
                                        valueField: 'id',
                                        labelField: 'name',
                                        column: 4,
                                        labelColumn: 3,
                                        inputColumn: 9
                                    },{
                                        available: true,
                                        type: 'submit',
                                        noLabel: true,
                                        label: 'fields.SAVE',
                                        column: 3,
                                        labelColumn: 0,
                                        inputColumn: 12
                                    },{
                                        available: true,
                                        type: 'button',
                                        noLabel: true,
                                        label: 'labels.DELETE',
                                        column: 1,
                                        labelColumn: 0,
                                        inputColumn: 12,
                                        cls: 'btn-danger',
                                        onClick: function(form, event){
                                            event.preventDefault()
                                            event.stopPropagation()
                                            var self = form;
                                            ngDialog.openConfirm({
                                                template: '/app/views/entities/confirm.html',
                                                className: 'ngdialog-theme-default',
                                                scope: $scope
                                              }).then(function (value) {
                                                self.model.action = 'SaveSector';
                                                self.model.deleteSector = true
                                                R.one('group', $scope.id)
                                                    .customPUT(self.model)
                                                    .then(function(resp){
                                                        self.status = 'submitted';
                                                        $scope.init()
                                                    })
                                              })
                                        }
                                    }],
                                    validate: function(){
                                        var errors = [];
                                        for(var i=0; i<this.fields.length; i++){
                                            var field = this.fields[i];
                                            if(field.required && !this.model[field.name]){
                                                errors.push({field:field,error:'required'});
                                            }
                                        }
                                        if(errors.length) {
                                            var errorMessages ="<ul>";
                                            for(var i=0; i<errors.length; i++){
                                                var e = errors[i];
                                                errorMessages += "<li>"
                                                    +$filter('translate')('labels.VALIDATIONERROR'+e.error.toUpperCase(), { name: $filter('translate')('fields.'+e.field.name.toUpperCase()) })
                                                    +"</li>";
                                            }
                                            errorMessages += "</ul>";
                                            $scope.pop('error', $filter('translate')('labels.NOTVALIDFORM'), errorMessages);
                                            return false;
                                        }
                                        else return true;
                                    },
                                    submit: function(){
                                        if(this.validate()){
                                            var self = this;
                                            self.status = 'submitting'
                                            self.model.action = 'SaveSector';
                                            R.one('group', $scope.id)
                                                .customPUT(self.model)
                                                .then(function(resp){
                                                    self.status = 'submitted';
                                                    $scope.init()
                                                })
                                        }
                                    }
                                    
                                }
                            }

                            }).catch(console.error)
                         
                     }).catch(console.error);
                     
                     
                 } 




             } else {
                 if (!$scope.watchActivated) {
                     $scope.watchActivated = true;
                     $rootScope.$watch('user.id', function () {
                         if (!$scope.initialized) {
                             $scope.init();
                         }
                     });
                 }
             }
         }

         

         $scope.init();
     }
 ]);